import React from 'react';
import Wrapper from '../assets/wrappers/MachineProductDriverSmall';
import { useAppContext } from '../context/appContext';
import moment from 'moment';

const MachineProductStockerSmall = ({
  _id,
  productName,
  productType,
  location,
  price,
  sales,
  maxStock,
  currentStock,
  stocked,
  stockedDate,
  stockerReplaced,
  stockerReplacedProductName,
  stockerReplacedProductType,
  stockerReplacedProductPrice,
  stockerReplacedProductMaxStock,
  replaceFlag,
  independentPricing,
}) => {
  const { updateProductInfoView } = useAppContext();

  let date = moment(stockedDate);
  date = date.format('MMM Do, YYYY, h:mm:ss a ');

  const neededStock = maxStock - currentStock;

  let needsFill = false;

  if (currentStock <= maxStock * 0.5 && maxStock > 0) {
    needsFill = true;
  }

  const handleClick = () => {
    // Handle the click event
    updateProductInfoView(
      _id,
      productName,
      productType,
      location,
      price,
      sales,
      maxStock,
      currentStock,
      stocked,
      stockedDate,
      stockerReplaced,
      stockerReplacedProductName,
      stockerReplacedProductType,
      stockerReplacedProductPrice,
      stockerReplacedProductMaxStock,
      replaceFlag,
      independentPricing,
    );
  };

  return (
    <Wrapper>
      <div onClick={handleClick} style={{ cursor: 'pointer' }}>
        <header>
          {maxStock === 0 ? (
            <div className={'main-icon no-stock'}>{location}</div>
          ) : stocked > 0 ? (
            <div className={'main-icon filled'}>{location}</div>
          ) : (
            <div className={needsFill ? 'main-icon needs-fill' : 'main-icon'}>
              {location}
            </div>
          )}
          <div className='info'>
            <h5>{productName}</h5>
          </div>
        </header>
      </div>
    </Wrapper>

    // <Wrapper>
    //      <div onClick={handleClick} style={{ cursor: 'pointer' }}>
    //         <header>
    //             <div className={currentStock <= (maxStock * 0.5) ? 'main-icon needs-fill' : 'main-icon'}>
    //                 {location}
    //             </div>
    //             <div className='info'>
    //                 {productName}
    //             </div>
    //         </header>
    //     </div>
    // </Wrapper>
  );
};

export default MachineProductStockerSmall;
